import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import store, { RootState } from "../../store";
import axios from "axios";
import _ from "lodash";

interface UpdateOrderParams {
  orderId?: string;
  status: string | null;
  paidProducts?: any;
  vendeur: String | null;
}

/**
 * list  of rapports
 * @public
 */
export const findRapportAchatVenteApi = createAsyncThunk(
  "rapport/findRapportAchatVenteApi",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `rapport/findRapportAchatVenteApi`,
        data,
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  },
);

/**
 * Get list of clients with number of orders, total of orders and fidelity points.
 * @public
 */
export const findRapportClientApi = createAsyncThunk(
  "rapport/findRapportClientApi",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`rapport/findRapportClientApi`, data);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  },
);

/**
 * Get list of  val stock by filtre .
 * @public
 */
export const ValstockfilterApi = createAsyncThunk(
  "rapport/ValstockfilterApi",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`rapport/ValstockfilterApi`, data);
      console.log("response.data", response.data);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  },
);
export const ValstockfilterApiExcel = createAsyncThunk(
  "rapport/ValstockfilterApiExcel",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(`rapport/ValstockfilterApiExcel`, data, {
        responseType: 'blob', // IMPORTANT : pour gérer les fichiers binaires
      });

      // Création d'un lien temporaire pour télécharger le fichier
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Etat_de_Stock.xlsx'); // Nom du fichier
      document.body.appendChild(link);
      link.click();
      
      // Nettoyage
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: "Erreur lors du téléchargement de l'Excel",
      });
    }
  }
);;


interface rapportState {
  listrapport: any[];
  listValstock: any;
  totalPrix: any;
  totalQte: any;
  cuurentPage: number;
  totalOages: number;
  listRapportClient: any[];
  currentPageClient: number;
  totalPagesClient: number;
}

const initialState: rapportState = {
  listrapport: [],
  listValstock: [],
  totalPrix: null,
  totalQte: null,
  cuurentPage: 0,
  totalOages: 0,
  listRapportClient: [],
  currentPageClient: 0,
  totalPagesClient: 0,
};

export const rapportSlice = createSlice({
  name: "rapports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findRapportAchatVenteApi.fulfilled, (state, action) => {
      console.log("action.payload;", action.payload);
      state.listrapport = action.payload;
    });
    builder.addCase(ValstockfilterApi.fulfilled, (state, action) => {
      state.listValstock = action.payload.data;
      state.totalQte = action.payload.QteTotal;
      state.totalPrix = action.payload.Totalprix;
      state.cuurentPage = action.payload.pagination.currentPage;
      state.totalOages = action.payload.pagination.totalPages;
    });
    builder.addCase(findRapportClientApi.fulfilled, (state, action) => {
      state.listRapportClient = action.payload.data;
      state.currentPageClient = action.payload.currentPage;
      state.totalPagesClient = action.payload.totalPages;
    });
  },
});

export const Listrapport = (state: RootState) => state.rapport.listrapport;
export const TotalPrix = (state: RootState) => state.rapport.totalPrix;
export const TotalQte = (state: RootState) => state.rapport.totalQte;
export const ListValstock = (state: RootState) => state.rapport.listValstock;

export const currentPage = (state: RootState) => state.rapport.cuurentPage;

export const totalPages = (state: RootState) => state.rapport.totalOages;

export const ListRapportClient = (state: RootState) =>
  state.rapport.listRapportClient;
export const currentPageClient = (state: RootState) =>
  state.rapport.currentPageClient;
export const totalPagesClient = (state: RootState) =>
  state.rapport.totalPagesClient;

export default rapportSlice.reducer;
